/* Service worker + web notifications registration */
export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/service-worker.js");
    // Immediately check for updates on every app load
    reg.update().catch(() => {});

    // If a waiting SW is already present, force it to take over now
    if (reg.waiting) {
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    // Auto-update when a new SW version is found
    reg.addEventListener("updatefound", () => {
      const installing = reg.installing;
      if (!installing) return;
      installing.addEventListener("statechange", () => {
        if (installing.state === "installed") {
          // Whether or not a controller already exists, tell the new SW to activate
          installing.postMessage({ type: "SKIP_WAITING" });
        }
      });
    });
    // Reload once when the new SW takes control so clients get fresh assets
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
    // Poll for updates every 5 minutes
    setInterval(() => reg.update().catch(() => {}), 5 * 60 * 1000);
    return reg;
  } catch (e) {
    console.warn("SW registration failed:", e);
    return null;
  }
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  const res = await Notification.requestPermission();
  return res;
}

export async function showLocalNotification(title, body, url = "/dashboard") {
  const perm = await requestNotificationPermission();
  if (perm !== "granted") return false;
  const reg = await navigator.serviceWorker.getRegistration();
  if (reg) {
    reg.showNotification(title, { body, icon: "/favicon.ico", badge: "/favicon.ico", data: { url } });
  } else if ("Notification" in window) {
    new Notification(title, { body, icon: "/favicon.ico" });
  }
  return true;
}

/**
 * Schedule a local reminder (runs only while the app tab is open).
 * For real push while app is closed, a backend VAPID server is required —
 * out of scope for this MVP.
 */
export function scheduleReminder(title, body, whenMs, url = "/dashboard") {
  const delay = Math.max(0, whenMs - Date.now());
  return setTimeout(() => showLocalNotification(title, body, url), delay);
}
